// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { AnimatePresence } from 'framer-motion';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import React, { useContext, useState } from 'react';
import { sortMembers } from 'utilities/sortMembers';
import { ProjectDetailsContext } from '../../ProjectDetails';
import './GroupManager.module.scss';
import Member from './Member/Member';
import AddMemberModal from './Modals/AddMemberModal/AddMemberModal';
import UploadImageModal from './Modals/UploadImageModal/UploadImageModal';
// =========================

export default function GroupManager() {
  const { project, userMembership } = useContext(ProjectDetailsContext);

  const avatar = useRedux((state) => state.authentication?.user.avatar_url);
  const hasImage = avatar && avatar.length > 1;

  const [addMemberModalIsOpen, setAddMemberModalIsOpen] = useState(false);
  const [uploadImageModalIsOpen, setUploadImageModalIsOpen] = useState(false);

  const members = sortMembers(project);

  const isStudent = usePermission(['Leerling', 'Leerling Portfolio']);

  const canAddMember =
    isStudent && (userMembership === 'admin' || userMembership === 'owner');

  return (
    <>
      <div styleName="scroll-wrapper">
        <div styleName="wrapper">
          {members?.map((member, index) => (
            <Member member={member.member} key={index} />
          ))}

          {canAddMember && members && members?.length <= 19 && (
            <CircleButton
              icon={faPlus}
              color="grey-blue"
              onClick={() =>
                !hasImage
                  ? setUploadImageModalIsOpen(true)
                  : setAddMemberModalIsOpen(true)
              }
            />
          )}
        </div>
      </div>
      <AnimatePresence>
        {addMemberModalIsOpen && (
          <AddMemberModal setModalIsOpen={setAddMemberModalIsOpen} />
        )}
        {uploadImageModalIsOpen && (
          <UploadImageModal
            setModalIsOpen={setUploadImageModalIsOpen}
            setAddMemberModalIsOpen={setAddMemberModalIsOpen}
          />
        )}
      </AnimatePresence>
    </>
  );
}
